import { useSyncExternalStore } from 'react';

import { getCurrentTenant, subscribeCurrentTenant } from './client';

/**
 * Correspondente selecionado na casca, reativo: re-renderiza na troca (o `currentTenantId` do
 * `useTenant()` legado). Quem põe o tenant na chave e no fio lê daqui, não de `getCurrentTenant()`.
 */
export function useCurrentTenant(): string | undefined {
  return useSyncExternalStore(subscribeCurrentTenant, getCurrentTenant, getCurrentTenant);
}
